import React, { useState } from 'react'
import TextInput from '../form/TextInput'
import Button1 from '../form/Button1'
import sendCustomerInvoice from '../../controllers/booking/sendCustomerInvoice'
import { enqueueSnackbar } from 'notistack'

export default function SendInvoiceToCustomer({id,close,callback}) {
    const [data,setData] = useState({email: ''})
    const [loadings,setLoadings] = useState({submit: false})

    async function handleSubmit() {
        setLoadings({...loadings,submit: true})
        const res = await sendCustomerInvoice({...data,flightBookingId: id})
        if(res?.return) {
            callback && callback()
        } else enqueueSnackbar(res.msg,{variant: 'error'})
        setLoadings({...loadings,submit: false})
    }
    
  return (
    <div className='flex flex-col gap-4 p-6'>
      <TextInput label='Customer Email' value={data?.email}
        onChange={(ev) => setData({...data,email: ev.target.value})} />
        <div className='flex gap-4 items-center'>
            {close && <div>
                <Button1 variant='text' onClick={() => close()}>Cancel</Button1>
            </div>}
            <Button1 onClick={() => handleSubmit()} loading={loadings.submit}>Send</Button1>
        </div>
    </div>
  )
}
